import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=b431b64c&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=ts&"
export * from "./Results.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b431b64c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b431b64c')) {
      api.createRecord('b431b64c', component.options)
    } else {
      api.reload('b431b64c', component.options)
    }
    module.hot.accept("./Results.vue?vue&type=template&id=b431b64c&scoped=true&", function () {
      api.rerender('b431b64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/Results.vue"
export default component.exports